// src/services/presidenteService.js
import api from '../services/api';

export const listarPresidentes = async () => {
    return api.get('/presidentes');
};

export const obterPresidente = async (id) => {
    return api.get(`/presidentes/${id}`);
};

export const criarPresidente = async (presidente) => {
    return api.post('/presidentes', presidente);
};

export const atualizarPresidente = async (id, presidente) => {
    return api.put(`/presidentes/${id}`, presidente);
};

export const excluirPresidente = async (id) => {
    return api.delete(`/presidentes/${id}`);
};